import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _Skeleton, _Skeleton2, _Skeleton3, _Skeleton4;
var _excluded = ["sx"];
import React from 'react';
import { Box, Skeleton, extendSX } from '@lumahealthhq/ui-core';

/**
 * This is the Fallback component to render till the module is ready.
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function FallbackChartSankey(_ref) {
  var sx = _ref.sx,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(Box, _extends({
    sx: extendSX(sx, {
      width: '100%',
      height: 380,
      mb: 3,
      display: 'flex',
      gap: '22%'
    })
  }, rest, {
    children: [_Skeleton || (_Skeleton = /*#__PURE__*/_jsx(Skeleton, {
      variant: "rectangular",
      height: "80%",
      width: 36
    })), _Skeleton2 || (_Skeleton2 = /*#__PURE__*/_jsx(Skeleton, {
      variant: "rectangular",
      height: "80%",
      width: 36
    })), _Skeleton3 || (_Skeleton3 = /*#__PURE__*/_jsx(Skeleton, {
      variant: "rectangular",
      height: "100%",
      width: 36
    })), _Skeleton4 || (_Skeleton4 = /*#__PURE__*/_jsx(Skeleton, {
      variant: "rectangular",
      height: "100%",
      width: 36
    }))]
  }));
}